var _path, _path2, _path3, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGtm = function SvgGtm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB4F8",
    d: "M111.31 176.79 80.76 147l65.61-67L178 111z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M111.44 45.08 81 14 14.44 79.93c-8.58 8.58-8.58 22.49 0 31.08L80 177l31-29-49.95-52.53 50.39-50.39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB4F8",
    d: "m177.56 80.44-66-66c-8.59-8.59-22.52-8.59-31.11 0s-8.59 22.52 0 31.11l66 66c8.59 8.59 22.52 8.59 31.11 0s8.59-22.52 0-31.11z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#246FDB",
    cx: 95.5,
    cy: 162.5,
    r: 21.5
  })));
};

export default SvgGtm;